import React, { Component } from "react";
import { Upload, Icon, Modal, Button } from "antd";

const { Dragger } = Upload;

class ModalUpload extends Component {
  render() {
    return (
      <Modal
        bodyStyle={{ height: 500 }}
        confirmLoading={this.props.confirmLoading}
        okButtonProps={{ disabled: this.props.isButtonSend }}
        title="Upload Banner"
        visible={this.props.visible}
        onCancel={() => this.props.visibleModal()}
        onOk={() => this.props.uploadBanner(this.props.selectedImage)}>
        <h3>Silahkan Input Banner (1920 * 1080 Pixels)</h3>
        {this.props.selectedImage && (
          <div>
            <img
              alt="Banner"
              width={"100%"}
              height={"350px"}
              src={URL.createObjectURL(this.props.selectedImage)}
            />
            <br />
            <Button
              style={{ marginTop: 10 }}
              type="danger"
              onClick={() => this.props.setSelectedImage(null)}>
              Remove
            </Button>
          </div>
        )}
        <input
          type="file"
          name="myImage"
          onChange={event => {
            this.props.setSelectedImage(event.target.files[0]);
          }}
          style={{ marginTop: 10 }}
          accept="image/*"
        />
      </Modal>
    );
  }
}

export default ModalUpload;



// WEBPACK FOOTER //
// src/components/Dashboard/BannerList/ModalUpload.js